const ALL_CATEGORIES = {
  label: 'All Categories',
  value: 'all-categories'
};

const PAGE_SIZE = 100;

export {
  ALL_CATEGORIES,
  PAGE_SIZE,
}



// WEBPACK FOOTER //
// ./src/constants/events.js